import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { EditRAPI, EditRecruiter, uploadLogo } from "../../api/recruiter";
import { planListAPI } from "../../api/plan";
import { roleMenuForRecruiterAPI } from "../../api/role";
import swal from "sweetalert";
import moment from "moment";

const EditR = (props) => {
  //console.log(props);

  const { editModal, setEditModal, dataFetch, editid, setEditContactId } =
    props;
  const [editFormData, setEditFormData] = useState({});
  const [totalDays, setTotalDays] = useState("");
  const [path, setPath] = useState("");
  const [planlist, setPlanList] = useState([]);
  const [menulist, setMenuList] = useState([]);
  const [recruiterType] = useState([
    { id: 1, name: "Regular" },
    { id: 2, name: "Non-Regular" },
  ]);

  useEffect(() => {
    if (editid > 0 && editModal) {
      updateFormData();
    }
  }, [editid, editModal]);

  useEffect(() => {
    if (!editModal) {
      setEditFormData({});
    }
  }, [editModal]);

  const updateFormData = async () => {
    const { data } = await EditRAPI(editid);

    let [formValues] = data.data;
    formValues.publish = formValues.status;
    setPath(data.path);
    formValues.change_img = false;

    let rtArr = formValues.recruiter_type?.split(",");
    let rtsArr = recruiterType.filter((s) => {
      return rtArr.includes(`${s.id}`);
    });

    setEditFormData({
      ...formValues,
      recruiter_type: rtsArr?.map((rt) => ({ value: rt.id, label: rt.name })),
      plan_expire_date: formValues.plan_expire_date.split(" ")[0],
      extension_date: formValues.extension_date
        ? formValues.extension_date.split(" ")[0]
        : "",
      job_posting_date: formValues.job_posting_date
        ? formValues.job_posting_date.split(" ")[0]
        : "",
      resume_access_date: formValues.resume_access_date
        ? formValues.resume_access_date.split(" ")[0]
        : "",
      recruiter_email: formValues.email,
    });

    //setEditFormData({ ...formValues });
    fetchData();
  };

  const fetchData = async () => {
    let plan = await planListAPI();
    setPlanList(plan);
    let mdata = await roleMenuForRecruiterAPI();
    setMenuList(mdata);
  };

  const handleEditFormChange = (event) => {
    const fieldName = event.target.getAttribute("name");
    const fieldValue =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    let updatedFormData = { ...editFormData, [fieldName]: fieldValue };

    if (
      fieldName === "general_unlock_quota" ||
      fieldName === "applicants_unlock_quota"
    ) {
      updatedFormData.total_unlock_quota =
        parseInt(updatedFormData.general_unlock_quota || 0) +
        parseInt(updatedFormData.applicants_unlock_quota || 0);
    }

    setEditFormData(updatedFormData);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const menuId = name;
    let updatedMenus = [...editFormData.menus];
    if (checked) {
      updatedMenus.push(menuId);
    } else {
      updatedMenus = updatedMenus.filter((menu) => menu !== menuId);
    }
    setEditFormData({ ...editFormData, menus: updatedMenus });
  };

  const handleRTChange = (selectedOptions) => {
    //setEditFormData({ ...editFormData, menus: updatedMenus });
    setEditFormData((prevState) => ({
      ...prevState,
      recruiter_type: selectedOptions,
    }));
  };

  const handleAccessType = useCallback(
    (e, className) => {
      const data = {};
      const inputs = document.getElementsByClassName(className);
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (input.type === "checkbox" || input.type === "radio") {
          if (input.checked) {
            data[input.name] = 1;
          } else {
            if (input.name == "nonlgbt") {
              data["nonlgbt_man"] = 0;
              data["nonlgbt_woman"] = 0;
            }
            data[input.name] = 0;
          }
        } else {
          data[input.name] = 1;
        }
      }
      setEditFormData((pre) => ({ ...pre, ...data }));
    },
    [setEditFormData]
  );

  const handleEditFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";

    if (
      !editFormData.name ||
      !editFormData.company_name ||
      !editFormData.recruiter_email ||
      editFormData.recruiter_type.length < 1 ||
      editFormData.menus.length === 0
    ) {
      error = true;
      errorMsg = "Please fill in all required fields";
    }

    if (!error) {
      editFormData.recruiter_type = editFormData.recruiter_type
        .map((rt) => rt.value)
        .join(",");
      editFormData.status = editFormData.publish;
      let res = await EditRecruiter(editFormData, editid);

      if (res !== false) {
        if (res?.error) {
          swal("Oops", res?.error, "error");
        } else {
          dataFetch(true);
          setEditContactId(null);
          setEditFormData({});
          setEditModal(false);
          swal(
            "Successfully Updated Event!",
            "Successfully Updated",
            "success"
          );
        }
      } else {
        swal(
          "Oops",
          "Some problem occurs. Please contact administrator.",
          "error"
        );
      }
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const isFormValid = () => {
    return (
      editFormData.name &&
      editFormData.company_name &&
      editFormData.recruiter_email &&
      editFormData.recruiter_type.length > 0 &&
      editFormData.menus.length > 0
    );
  };

  const dateDifference = useCallback((dateA, dateB) => {
    const date1 = new Date(dateA);
    const date2 = new Date(dateB);

    const timeDiff = Math.abs(date2 - date1);
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
  }, []);

  const calculateDays = useCallback(
    (formdata) => {
      setTotalDays("");
      if (
        formdata?.extension_date !== "" &&
        formdata?.extension_date > formdata?.plan_expire_date
      ) {
        const difference = dateDifference(
          formdata?.plan_expire_date,
          formdata?.extension_date
        );
        setTotalDays(difference);
      }
    },
    [setTotalDays]
  );

  useEffect(() => {
    calculateDays(editFormData);
  }, [editFormData]);

  const handleUploadImage = useCallback(
    (name, file) => {
      //setImageUploading({ uploding: true, name: name });
      var filePath = file.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(filePath)) {
        //error("Please upload file having extensions .jpeg/.jpg/.png only.");
        swal(
          "Oops",
          "Please upload file having extensions .jpeg/.jpg/.png only.",
          "error"
        );
        return false;
      }
      uploadLogo(file)
        .then((res) => {
          if (res.data?.data) {
            setEditFormData({
              ...editFormData,
              [name]: res.data?.data,
              change_img: true,
            });
          } else {
            console.log(res.data?.error);
          }
          //setImageUploading({ uploding: false, name: null });
        })
        .catch((err) => {
          //setImageUploading({ uploding: false, name: null });
          console.log(err);
        });
    },
    [editFormData, setEditFormData]
  );
  

  return (
    <Modal
      className="modal fade bd-example-modal-lg"
      show={editModal}
      onHide={() => setEditModal(false)}
      centered
      size="lg"
    >
      <div role="document">
        <div className="">
          <form autoComplete="off">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Update Recruiter</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setEditModal(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Company Logo
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          name="company_logo"
                          onChange={(e) => {
                            handleUploadImage(
                              "company_logo",
                              e.target.files[0]
                            );
                          }}
                          //value={addFormData.name}
                          //onChange={handleAddFormChange}
                        />
                      </div>
                    </div>
                    {}
                    {editFormData.company_logo !== undefined &&
                      editFormData.company_logo !== "" &&
                      editFormData.company_logo !== null && (
                        <div className="col-md-6 mb-3">
                          <img
                            width="100px"
                            src={path + editFormData.company_logo}
                          />
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="text-black font-w500">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          defaultValue={editFormData.name || ""}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Company Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_name"
                          defaultValue={editFormData.company_name || ""}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="text-black font-w500">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="recruiter_email"
                          defaultValue={editFormData.recruiter_email || ""}
                          onChange={handleEditFormChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="text-black font-w500">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          name="recruiter_password"
                          defaultValue={editFormData.recruiter_password || ""}
                          onChange={handleEditFormChange}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Plan Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="planname"
                          defaultValue={editFormData.plan_name || ""}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Plan Expiry Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          autoComplete="off"
                          name="plan_expire_date"
                          defaultValue={editFormData.plan_expire_date || ""}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Extension date
                        </label>
                        <input
                          type="date"
                          min={editFormData.plan_expire_date}
                          className="form-control"
                          autoComplete="off"
                          name="extension_date"
                          defaultValue={editFormData.extension_date || ""}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Extension days
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          //min={minDate}
                          autoComplete="off"
                          name="extension_days"
                          value={totalDays}
                          readOnly
                          //defaultValue={editFormData.extension_date || ""}
                          //onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-4 my-2">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Actively hiring
                        </label>
                        <select
                          className="form-select"
                          name="actively_hiring"
                          value={editFormData?.actively_hiring}
                          defaultValue={
                            editFormData.actively_hiring === 0
                              ? "0"
                              : editFormData.actively_hiring === 1
                              ? "1"
                              : ""
                          }
                          onChange={handleEditFormChange}
                        >
                          <option value="">Select </option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4 my-2">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Job posting date
                        </label>
                        <div>
                          <input
                            type="date"
                            min={editFormData.job_posting_date}
                            className="form-control"
                            autoComplete="off"
                            name="job_posting_date"
                            defaultValue={editFormData.job_posting_date || ""}
                            onChange={handleEditFormChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 my-2">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Resume access date
                        </label>
                        <div>
                          <input
                            type="date"
                            min={editFormData.resume_access_date}
                            className="form-control"
                            autoComplete="off"
                            name="resume_access_date"
                            defaultValue={editFormData.resume_access_date || ""}
                            onChange={handleEditFormChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="text-black font-w500 mt-2">
                        Access type
                      </label>
                      <div className="contact-name">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input access_type"
                            type="checkbox"
                            name="lgbt_confirmed"
                            value="1"
                            id="lgbt_confirmed"
                            onChange={(e) => handleAccessType(e, "access_type")}
                            defaultChecked={editFormData?.lgbt_confirmed === 1}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="lgbt_confirmed"
                          >
                            LGBT Confirmed
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input access_type"
                            type="checkbox"
                            name="nonlgbt"
                            value="1"
                            id="nonlgbt"
                            onChange={(e) => handleAccessType(e, "access_type")}
                            defaultChecked={editFormData.nonlgbt}
                          />
                          <label className="form-check-label" htmlFor="nonlgbt">
                            Non LGBT+
                          </label>
                        </div>
                        {editFormData.nonlgbt === 1 && (
                          <>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="nonlgbt_man"
                                value="1"
                                id="nonlgbt_man"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                                defaultChecked={editFormData?.nonlgbt_man === 1}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="nonlgbt_man"
                              >
                                Man
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="nonlgbt_woman"
                                value="1"
                                id="nonlgbt_woman"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                                defaultChecked={
                                  editFormData?.nonlgbt_woman === 1
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="nonlgbt_woman"
                              >
                                Woman
                              </label>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="text-black font-w500">Menus</label>
                        <div className="form-check">
                          {menulist.map((menu, index) => (
                            <div
                              key={menu.id}
                              className="form-check"
                              style={{
                                display: "inline-block",
                                width: "48%",
                                marginRight: "4%",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name={menu.id.toString()}
                                checked={
                                  editFormData.menus?.includes(
                                    menu.id.toString()
                                  ) || false
                                }
                                onChange={handleCheckboxChange}
                              />
                              <label className="form-check-label">
                                {menu.menu_name}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Total Unlock Quota
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="total_unlock_quota"
                          defaultValue={editFormData.total_unlock_quota || ""}
                          onChange={handleEditFormChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          General Unlock Quota
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="general_unlock_quota"
                          defaultValue={editFormData.general_unlock_quota || ""}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Applicants Unlock Quota
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="applicants_unlock_quota"
                          defaultValue={
                            editFormData.applicants_unlock_quota || ""
                          }
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Jobs Limit
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="jobs_limit"
                          defaultValue={editFormData.jobs_limit || ""}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Sub Recruiter Quota
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="sub_recruiter_quota"
                          defaultValue={editFormData.sub_recruiter_quota || ""}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Total Unlocked Used
                        </label>
                        <label className="form-control">
                          {editFormData.total_unlocked_used || 0}
                        </label>
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          General Unlock Used
                        </label>
                        <label className="form-control">
                          {editFormData.general_unlock_used || 0}
                        </label>
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Applicants Unlock Used
                        </label>
                        <label className="form-control">
                          {editFormData.applicants_unlock_used || 0}
                        </label>
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Jobs Limit Used
                        </label>
                        <label className="form-control">
                          {editFormData.jobs_limit_used || 0}
                        </label>
                      </div>
                      <div className="form-group mt-2">
                        <label className="text-black font-w500">
                          Sub Recruiter Quota Used
                        </label>
                        <label className="form-control">
                          {editFormData.sub_recruiter_quota_used || 0}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Publish Status
                        </label>
                        <div>
                          <input
                            type="radio"
                            className="form-check-input"
                            name="publish"
                            value="1"
                            checked={editFormData.publish == "1"}
                            onChange={handleEditFormChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="publishActive"
                          >
                            Active &nbsp;&nbsp;&nbsp;
                          </label>
                          <input
                            type="radio"
                            className="form-check-input"
                            name="publish"
                            value="0"
                            checked={editFormData.publish != "1"}
                            onChange={handleEditFormChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="publishInactive"
                          >
                            Inactive
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-success"
                onClick={handleEditFormSubmit}
                disabled={!isFormValid()}
              >
                Update
              </button>
              <button
                type="button"
                onClick={() => setEditModal(false)}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Discard
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default EditR;
